<template>
  <div class="sm_star">
    <!-- header -->
    <TopAppBar
      :leftBtnMode="leftBtnMode"
      :rightBtnMode="rightBtnMode"
      :title="title"
      :leftBtnMethod="leftBtnMethod"
      :rightBtnMethod="rightBtnMethod"
      :rightBtnTxt="rightBtnTxt"
      :rightBtnTxtMethod="rightBtnTxtMethod"
    >
    </TopAppBar>
    <!-- //header -->

    <!-- content -->
    <div class="sm_wrap">
      <div class="bg-white lanuage_wrap">
        <div class="lanuage_search">
          <input
            type="search"
            :placeholder="$t('1299')"
            class="search_input"
            v-model="search"
          />
          <button type="button" class="search_btn">검색</button>
        </div>

        <div class="lanuage_list">
          <ul>
            <li v-for="(language, index) in searchLang()" :key="index">
              <input
                type="radio"
                :id="language.code"
                name="lanuage_radio"
                @click="changeLanguage(language)"
                :checked="isSelectedLang(language)"
              />
              <label :for="language.code">{{ language.text }}</label>
            </li>
            <!-- <li><input type="radio" id="English" name="lanuage_radio"><label for="English">English</label></li>
						<li><input type="radio" id="Arabic" name="lanuage_radio"><label for="Arabic">العربية</label></li>
						<li><input type="radio" id="Bengali" name="lanuage_radio"><label for="Bengali">বাংলা</label></li>
						<li><input type="radio" id="Chinese" name="lanuage_radio"><label for="Chinese">简体中文</label></li>
						<li><input type="radio" id="traditional Chinese" name="lanuage_radio"><label for="traditional Chinese">繁體中文</label></li>
						<li><input type="radio" id="Hrvatski" name="lanuage_radio"><label for="Hrvatski">Hrvatski</label></li>
						<li><input type="radio" id="Czech" name="lanuage_radio"><label for="Czech">Čeština</label></li>
						<li><input type="radio" id="dansk" name="lanuage_radio"><label for="dansk">dansk</label></li>
            <li><input type="radio" id="Nederlands" name="lanuage_radio"><label for="Nederlands">Nederlands</label></li>-->
          </ul>
        </div>
      </div>
    </div>
    <!-- //content -->
  </div>
</template>
<script>
import i18nApi from "@/api/i18nApi.js";
import { setUserLanguage } from "@/translations/i18nSetup";
import { mapState, mapMutations } from "vuex";
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "../mixins/topAppBar.js";

export default {
  name: "languageSearch",
  data() {
    return {
      isLanguageSelect: false,
      languageList: [],
      search: "",
    };
  },
  components: {
    TopAppBar,
  },
  mixins: [topAppBarMixin],
  computed: {
    ...mapState(["languageMode"]),
  },

  mounted() {
    let params = {
      brandCode: localStorage.getItem("brandCode"),
    };

    if (localStorage.getItem("brandCode")) {
      // 브랜드 언어 목록 가져오기(get service language list)
      i18nApi.guestLanguagePack(params).then((response) => {
        this.languageList = response.data.data;
      });
    }

    this.setTopAppBarLangCloseOnly(this.$t("1298"));
  },
  methods: {
    ...mapMutations(["SET_LANGUAGE_MODE"]),
    // 언어 목록 토글(toggle language list)
    toggleLanguageSelect() {
      this.isLanguageSelect = !this.isLanguageSelect;
    },
    // 언어 변경(change language)
    changeLanguage(lang) {
      setUserLanguage(lang.code).then(() => {
        this.callPushNotification(lang.code);
        this.$emit("closeDrawer");
      });
    },
    searchLang() {
      return this.languageList.filter((lang) => {
        return lang.code.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
      });
    },
    isSelectedLang(lang) {
      return JSON.parse(localStorage.getItem("languageInfo")).code == lang.code;
    },
    callPushNotification(lanCode) {
      if (localStorage.getItem("fbToken") !== "undefined") {
        let params = {
          options: {
            pushToken: localStorage.getItem("fbToken"),
            pushLanguage: lanCode,
          },
        };
        i18nApi.callPushNotificationApi(params).then((response) => {
          let responseData = response.data.data;
          // console.log("calling on language change", response.data.data);
        });
      }
    },
  },
};
</script>
<style scoped>
.sm_star * {
  margin: 0;
  padding: 0;
  font-family: "Roboto", Arial, dotum, sans-serif;
  font-weight: normal;
  font-size: 13px;
  color: #222;
}
ol,
ul,
li {
  list-style: none;
}
table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  table-layout: fixed;
}
th {
  font-weight: normal;
}
form,
fieldset,
iframe {
  display: block;
  border: 0;
}
img,
button {
  border: none;
  vertical-align: middle;
}
hr {
  height: 0;
  display: none;
}
i,
em,
address {
  font-style: normal;
}
label,
button {
  cursor: pointer;
}
blockquote,
q {
  quotes: none;
}
caption,
.hide {
  visibility: hidden;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -9999em;
}
legend {
  overflow: hidden;
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
  padding: 0;
  margin: 0;
  font-size: 0;
  text-indent: -100%;
  white-space: nowrap;
  z-index: -1;
}
input[type="text"],
input[type="password"],
input[type="email"],
input[type="search"],
input[type="image"],
input[type="tel"],
textarea {
  -webkit-appearance: none;
  -webkit-border-radius: 0;
}
input:focus {
  outline: none;
}
::-webkit-input-placeholder {
  color: #999;
}
::-moz-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
::-webkit-selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}
a {
  color: #222;
  text-decoration: none;
}
a:link,
a:visited {
  text-decoration: none;
}
button {
  display: inline-block;
  background: none;
  border: none;
  outline: none;
}
::selection {
  background: #005aab;
  color: #fff;
  text-shadow: none;
}

/* header */
.sm_star {
  position: relative;
  margin: 0 auto;
}
.sm_star.backBg:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 997;
}
.sm_header {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e9e9e9;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
}
.sm_header h1 {
  text-align: center;
  color: #212121;
  font-size: 20px;
  font-weight: normal;
  height: 55px;
  line-height: 55px;
}
.sm_header .menu_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
}
.sm_header .menu_btn span {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  font-size: 0;
  display: inline-block;
}
.sm_header .menu_btn:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: -5px;
}
.sm_header .menu_btn:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin-top: 5px;
}
/* .sm_header .search_btn{width:55px; height:55px; position:absolute; right:0; top:0; font-size:0; text-align:center; background:url('../assets/search_btn.png') center center no-repeat; background-size:22px auto} */
.sm_header .search_btn span {
  font-size: 0;
  text-indent: -9999px;
}
/* .sm_header .back_btn{width:55px; height:55px; position:absolute; left:0; top:0; font-size:0; text-align:center; background:url(images/back_btn.png) center center no-repeat; background-size:22px auto; font-size:0; text-indent:-9999px}
		.sm_header .more_btn{width:55px; height:55px; position:absolute; right:0; top:0; font-size:0; text-align:center; background:url(images/more_btn.png) center center no-repeat; background-size:22px auto; font-size:0; text-indent:-9999px} */
.sm_header .more_box {
  position: absolute;
  right: 15px;
  top: 45px;
  width: 80px;
  z-index: 10;
}
.sm_header .close_btn {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  background: url("../assets/close_btn.png") center center no-repeat;
  background-size: 22px auto;
  font-size: 0;
  text-indent: -9999px;
}
.more_box {
  display: inline-block;
  padding: 15px 20px;
  background: #fff;
  box-shadow: 0 10px 13px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(206, 218, 220, 0.5);
  border-radius: 4px;
  display: none;
}
.more_box a {
  display: block;
  color: #333;
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  margin-bottom: 5px;
}
.more_box a:nth-last-child(1) {
  margin-bottom: 0;
}

.sm_header .upload_btn {
  width: 55px;
  height: 55px;
  line-height: 55px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  font-size: 15px;
  color: #2d6dcc;
}
.sm_header .upload_btn span {
  font-size: 15px;
  color: #2d6dcc;
  font-weight: 500;
}

.search_box {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10;
  display: none;
}
/* .search_box .search_close{width:55px; height:55px; position:absolute; left:0; top:0; font-size:0; text-align:center; background:url(./images/close_btn.svg) center center no-repeat; background-size:22px auto; text-indent:-9999px;} */
.search_box .search_form {
  position: absolute;
  left: 60px;
  top: 12px;
  border: 0;
  background: #fff;
  font-size: 18px;
  color: #212121;
  height: 30px;
  width: calc(100% - 125px);
}

/* layer img */
.layer_img {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
}
.layer_img .layer_close {
  width: 55px;
  height: 55px;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  text-align: center;
  z-index: 999;
}
.layer_img .layer_close:before {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(-45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .layer_close:after {
  width: 18px;
  height: 2px;
  background: #2d6dcc;
  display: inline-block;
  content: "";
  position: absolute;
  transform: rotate(45deg);
  margin-top: -2px;
  top: 50%;
  left: 50%;
  margin-left: -9px;
}
.layer_img .img_placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.layer_img .img {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.layer_img .img_placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.layer_img .img img {
  display: inline;
  max-width: 100%;
}

/* layer pop */
.layer_pop {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  z-index: 999;
  display: none;
}
.layer_con {
  width: 90%;
  max-width: 300px;
  background: #fff;
  box-sizing: border-box;
  padding: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
  box-shadow: 0 19px 38px 0 rgba(0, 0, 0, 0.26);
}
.layer_con .layer_txt {
  font-size: 16px;
  color: #818181;
  line-height: 1.5;
}
.layer_con .layer_btn {
  position: relative;
  padding: 30px 0 0 0;
  text-align: right;
}
.layer_con .layer_btn a {
  display: inline-block;
  padding: 5px 15px;
  color: #2d6dcc;
  font-weight: 500;
  font-size: 14px;
  margin-left: 10px;
}

/* upload */
.upload_wrap {
  position: relative;
  padding: 15px;
}
.upload_list {
  position: relative;
  font-size: 0;
}
.upload_list > li {
  display: inline-block;
  vertical-align: top;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 2%;
}
.upload_list > li:nth-child(3n) {
  margin-right: 0;
}
.upload_list .file {
  position: relative;
  height: 0;
  padding-top: 100%;
}
.upload_list .file > a {
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.upload_list .file img,
.upload_list .file video,
.upload_list .file iframe {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: cover;
  width: 100%;
  height: 100%;
}
.upload_list .file.active a:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(49, 61, 75, 0.3);
}
.upload_list .file .pic {
  display: inline-block;
  width: 25px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  color: #fff;
  background: #2d6dcc;
  font-size: 13px;
  position: absolute;
  right: 10px;
  top: 10px;
  border-radius: 50%;
  z-index: 10;
}

/* user */
.user_box {
  position: relative;
}
.user_box .user_img {
  position: relative;
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  width: 40px;
  height: 40px;
  vertical-align: middle;
  margin-right: 15px;
}
.user_box .user_img img {
  width: auto;
  height: auto;
  min-width: 100%;
  min-height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.user_box .user_txt {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}
.user_box .user_txt .name {
  font-size: 14px;
  color: #212121;
}
.user_box .user_txt .date {
  position: relative;
  padding: 2px 0 0 0;
  color: #818181;
  font-size: 14px;
}
.user_box .user_write {
  position: absolute;
  right: 0;
  top: 0;
}
.user_box .user_write > a {
  display: inline-block;
  vertical-align: top;
  margin-left: 15px;
  background-size: 24px auto !important;
}
/* .user_box .user_write .write_btn{font-size:12px; color:#acb4be; padding-top:28px; background:url(images/write_icon.png) center top no-repeat}
		.user_box .user_write .write_btn.me{background:url(images/my_write_icon.png) center top no-repeat} */
.user_box .user_date {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  color: #818181;
}
.user_fixed {
  position: fixed;
  left: 0;
  top: 55px;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 15px;
  z-index: 10;
}

/* style */
.sm_wrap {
  position: relative;
  padding: 55px 0 0 0;
}
.sm_list {
  position: relative;
}
.sm_list.view {
  padding-bottom: 85px;
}
.sm_list.learning {
  padding: 90px 15px 15px 15px;
  background: #f9f9f9;
  position: relative;
}
.sm_list_box {
  position: relative;
}
.sm_list_box > .list_box {
  position: relative;
  margin-bottom: 15px;
}
.sm_list_box > .list_box:nth-last-child(1) {
  margin-bottom: 0;
}
.sm_list .no_data {
  position: relative;
  height: calc(100vh - 210px);
  text-align: center;
  padding: 50px 0 0 0;
  min-height: 300px;
}
.sm_list .no_data .no_img img {
  max-width: 120px;
}
.sm_list .no_data p:nth-child(2) {
  position: relative;
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.sm_list .no_data p:nth-child(3) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}
.sm_list.view .list_box {
  margin-bottom: 0;
}

.list_box {
  position: relative;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  padding: 15px;
}
.list_box .user_con {
  padding: 15px 0 0 0;
}
.list_box .user_tag {
  padding: 10px 0 0 0;
}
.list_box .user_opt {
  margin: 20px 0 0 0;
}
.list_box .user_imgList {
  margin: 20px 0 0 0;
}
.user_con {
  position: relative;
  font-size: 14px;
  color: #818181;
  line-height: 1.57;
}
.user_con .em {
  color: #212121;
  margin-right: 5px;
  font-size: 14px;
}
.user_tag {
  position: relative;
  font-size: 0;
}
.user_tag span {
  display: inline-block;
  vertical-align: top;
  margin-right: 5px;
  font-size: 12px;
  color: #313d4b;
  padding: 2px 3px;
  background: #f4f5f6;
  border-radius: 2px;
}
.user_opt {
  position: relative;
  font-size: 12px;
  color: #818181;
}
.user_opt .right {
  position: absolute;
  right: 0;
  top: 0;
  color: #818181;
}
.list_btn {
  position: relative;
  text-align: center;
  font-size: 0;
  border-top: 1px solid #e6eced;
  margin: 15px 0 0 0;
  padding: 10px 0 0 0;
}
.list_btn a {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  padding: 0 10px 0 25px;
  background-size: 17px auto;
  background-position: left center;
  background-repeat: no-repeat;
  margin: 0 5px;
  color: #acb4be;
}
/* .list_btn a.like{background-image:url(images/like_btn.png)}
		.list_btn a.like.on{background-image:url(images/like_btn_on.png)} */
/* .list_btn a.reply{background-image:url(images/reply_btn.png)}
		.list_btn a.share{background-image:url(images/share_btn.png)} */
.user_imgList {
  position: relative;
  font-size: 0;
}
.user_imgList a {
  display: inline-block;
  position: relative;
}
.user_imgList a img {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}
.user_imgList a.more:before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.4;
  z-index: 1;
}
.user_imgList a.more span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  z-index: 2;
}
.user_imgList > a:nth-child(1) {
  width: 66%;
  height: 0;
  padding-top: 66%;
}
.user_imgList > a:nth-child(2) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  top: 0;
}
.user_imgList > a:nth-child(3) {
  width: 32%;
  height: 0;
  padding-top: 32%;
  position: absolute;
  right: 0;
  bottom: 0;
}
.user_imgList.view a {
  display: block;
  padding-top: 0;
  height: auto;
  position: relative;
  right: auto;
  top: auto;
  width: auto;
  margin-bottom: 10px;
}
.user_imgList.view a img {
  position: relative;
  left: 0;
  top: auto;
  width: auto;
  max-width: 100%;
  height: auto;
  transform: none;
}
.user_imgList.reply {
  margin: 0 0 0 55px;
  white-space: nowrap;
  overflow-x: auto;
}
.user_imgList.reply a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.input_file .user_imgList {
  white-space: nowrap;
  overflow-x: auto;
}
.input_file .user_imgList a {
  display: inline-block;
  width: 100px;
  height: 100px;
  padding-top: 0;
  position: relative;
  left: auto;
  top: auto;
  margin-right: 10px;
}
.user_imgList a.video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}
/* .user_imgList a.video:before{content:''; display:inline-block; width:25px; height:25px; background:url(images/play_icon.png) center center no-repeat; background-size:25px auto; position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); z-index:1} */

.reply_wrap {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
}
.reply_wrap > div:nth-last-child(1) {
  margin-bottom: 0;
}
.reply_box {
  position: relative;
  margin-bottom: 15px;
}
.reply_box .user_box .user_date {
  right: 40px;
  color: #a6a6a6;
}
/* .reply_box .user_box .more_btn{width:22px; height:22px; background:url(images/reply_more_btn.png) center center no-repeat; background-size:22px auto; position:absolute; right:0; top:0; font-size:0; text-indent:-9999px} */
.reply_box .user_con {
  padding: 10px 15px 10px 58px;
}
.reply_box .list_btn {
  text-align: left;
  border-top: 0;
  margin: 0;
  padding: 0 0 0 55px;
}
.reply_box > .reply_box {
  padding: 10px 0 0 50px;
}

.comment_box {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 50;
  padding: 15px 15px 20px 15px;
  background: #fff;
  box-sizing: border-box;
  border-top: 1px solid #e6eced;
}
.comment_area {
  position: relative;
}
.comment_area button {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-indent: -9999px;
  font-size: 0;
  position: absolute;
  top: 0;
  vertical-align: top;
}
/* .comment_area .picture_btn{background:url(images/picture_btn.png) center center no-repeat; background-size:22px auto; position:relative}
		.comment_area .video_btn{background:url(images/video_btn.png) center center no-repeat; background-size:22px auto; position:relative}
		.comment_area .comment_btn{background:url(images/comment_btn.png) center center no-repeat; background-size:22px auto; right:0}
		.comment_area .comment_btn.on{background:url(images/comment_btn_on.png) center center no-repeat; background-size:22px auto;} */
.comment_textarea {
  position: relative;
  vertical-align: top;
  font-size: 14px;
  background: none;
  border: 0;
  width: calc(100% - 130px);
  resize: none;
  outline: none;
  height: 25px;
  margin-top: 14px;
}
.comment_area .tail_txt {
  position: absolute;
  right: 0;
  top: 15px;
  font-size: 14px;
  color: #acb4be;
}

.search_list {
  position: relative;
  background: #f9f9f9;
  padding: 15px;
  min-height: calc(100vh - 85px);
}
.search_list .no_data {
  position: relative;
  text-align: center;
  padding: 30px 0 0 0;
  min-height: 300px;
}
.search_list .no_data p:nth-child(1) {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
.search_list .no_data p:nth-child(2) {
  position: relative;
  padding: 15px 0 0 0;
  font-size: 14px;
  font-weight: 500;
  color: #818181;
  line-height: 1.57;
}

.write_wrap {
  position: relative;
  padding-bottom: 85px;
}
.write_tag {
  position: relative;
  padding: 15px;
  background: #fff;
  border-bottom: 1px solid #e6eced;
}
.write_tag .tag_tail {
  position: relative;
  padding: 10px 15px 0 15px;
  font-size: 12px;
  color: #acb4be;
}
.write_tag .tag_form {
  position: relative;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid rgba(172, 180, 190, 0.7);
  min-height: 20px;
}
/* .write_tag .tag_form .tag_btn{width:25px; height:25px; font-size:0; text-indent:-9999px; background:url(images/addTag_icon.png) center center no-repeat; background-size:22px auto; vertical-align:middle; margin-right:5px} */
.write_tag .tag_form span.txt {
  font-size: 14px;
  color: #acb4be;
  vertical-align: middle;
  line-height: 1;
}
.write_tag .tag_form span.tag {
  display: inline-block;
  padding: 3px 5px;
  background: #f0f1f2;
  font-size: 14px;
  color: #313d4b;
  vertical-align: middle;
  margin-right: 3px;
  line-height: 1.4;
}
.write_tag .tag_form span.tag.txt {
  color: #313d4b;
  line-height: 1.4;
  background: none;
}
.write_form {
  position: relative;
  padding: 15px;
  background: #fff;
}
.write_form textarea {
  border: 0;
  background: none;
  font-size: 14px;
  color: #313d4b;
  line-height: 1.57;
  width: 100%;
  height: calc(100vh - 295px);
  box-sizing: border-box;
  min-height: 300px;
  resize: none;
  outline: none;
}

.tag_list {
  position: relative;
}
.tag_list ul {
  position: relative;
}
.tag_list ul li {
  position: relative;
  display: block;
  background: #f9f9f9;
  border-bottom: 1px solid #e6eced;
}
.tag_list ul li span {
  display: block;
  padding: 15px;
}

.input_file {
  position: fixed;
  left: 0;
  bottom: 85px;
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  z-index: 10;
  background: #fff;
}
.input_file + .write_form textarea {
  min-height: inherit;
  height: calc(100vh - 410px);
}

.edit_wrap {
  position: relative;
  height: calc(100vh - 55px);
  text-align: center;
  overflow-x: hidden;
  overflow-y: auto;
}
.edit_wrap .placer {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  white-space: nowrap;
  width: 100%;
}
.edit_wrap .placer:after {
  display: inline-block;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  content: "";
}
.edit_wrap .edit_file {
  display: inline-block;
  width: 100%;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
  position: relative;
}
.edit_wrap .edit_file img {
  display: inline;
  max-width: 100%;
}
.edit_wrap .edit_file .video {
  display: inline-block;
  position: relative;
}
.edit_wrap .edit_file .video:after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(49, 61, 75, 0.3);
  position: absolute;
  left: 0;
  top: 0;
}
/* .edit_wrap .edit_file .video:before{content:''; display:inline-block; width:50px; height:50px; background:url(images/play_icon.png) center center no-repeat; background-size:50px auto; position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); z-index:1} */

.sign_wrap {
  position: relative;
  padding: 15px 15px 75px 15px;
  background: #fff;
}
.sign_wrap > h2 {
  font-size: 22px;
  font-weight: bold;
  color: #212121;
}
.sign_wrap .sign_tail {
  position: relative;
  padding: 5px 0 0 0;
  color: #818181;
  font-size: 14px;
}
.sign_box {
  position: relative;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  border-radius: 4px;
  margin-top: 15px;
}
.sign_dl {
  position: relative;
  border-bottom: 1px solid rgba(172, 180, 190, 0.7);
}
.sign_dl dt {
  padding: 15px;
  color: #212121;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
/* .sign_dl dt:after{content:''; width:24px; height:24px; display:inline-block; background:url(images/open_bullet.png) center center no-repeat; position:absolute; right:15px; top:14px; background-size:18px auto !important} */
.sign_dl dd {
  position: relative;
  padding: 15px;
  color: #818181;
  font-size: 14px;
  line-height: 1.57;
  overflow: hidden;
  display: none;
}
.sign_dl.active dd {
  height: auto;
  display: block;
}
.sign_dl.active dt:after {
  background: url("../assets/close_bullet.png") center center no-repeat;
}
.sign_dl .support {
  position: relative;
  padding: 15px 0 0 0;
  color: #818181;
}
.sign_dl .support p {
  position: relative;
  margin-bottom: 5px;
  color: #818181;
}
.sign_dl .support p:nth-last-child(1) {
  margin-bottom: 0;
}
.sign_dl .support a {
  color: #80aed4;
  text-decoration: underline;
}
.sign_btn {
  position: relative;
  padding: 40px 0 0 0;
}
.sign_btn > p {
  position: relative;
  margin-bottom: 10px;
}
.sign_btn > p:nth-last-child(1) {
  margin-bottom: 0;
}
.sign_btn a {
  display: block;
  background: #cdd2d8;
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 15px 10px;
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
}
.sign_btn a.on {
  background: #2d6dcc;
}
.sign_pop {
  position: fixed;
  left: 10px;
  bottom: 15px;
  width: calc(100% - 20px);
  padding: 15px;
  color: #fff;
  font-size: 14px;
  border-radius: 4px;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.26);
  background: #000;
  box-sizing: border-box;
}

.lanuage_wrap {
  position: relative;
  padding: 15px;
}
.lanuage_search {
  position: fixed;
  background: #fff;
  left: 0;
  top: 55px;
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  background: #fff;
  z-index: 10;
}
.lanuage_search .search_input {
  background: none;
  padding: 15px 55px 15px 15px;
  font-size: 14px;
  box-sizing: border-box;
  width: 100%;
  border: 1px solid rgba(172, 180, 190, 0.7);
  border-radius: 4px;
  box-sizing: border-box;
}
.lanuage_search .search_btn {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url("../assets/search_btn_gray.png") center center no-repeat;
  text-indent: -9999px;
  overflow: hidden;
  background-size: 22px auto;
  position: absolute;
  right: 30px;
  top: 27px;
}
.lanuage_list {
  position: relative;
  padding: 15px 15px 15px 15px;
  margin-top: 60px;
}
.lanuage_list li {
  position: relative;
  margin-bottom: 15px;
}
.lanuage_list li:nth-last-child(1) {
  margin-bottom: 0;
}

.lanuage_list input {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  opacity: 0;
  filter: alpha(opacity=0);
  cursor: pointer;
}
.lanuage_list label {
  display: block;
  position: relative;
  z-index: 2;
  height: 20px;
  font-size: 15px;
  background: url("../assets/off_radio.png") center right no-repeat;
  background-size: 20px auto;
  color: #818181;
}
.lanuage_list input:checked + label {
  background: url("../assets/on_radio.png") center right no-repeat;
  background-size: 20px auto;
  color: #212121;
}
</style>
